
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contentPage/ContentPage",
      function () {
        return require("private-next-pages/contentPage/ContentPage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contentPage/ContentPage"])
      });
    }
  